import { faFileDownload } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import DataList from "components/DataList"
import VerticalTimeline from "components/VerticalTimeLine"
import moment from "moment"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import {
  downloadFile,
  getRequestInfo,
  getRequestSteps,
} from "services/support/calls"
import SimpleBar from "simplebar-react"

const ChamadosModal = props => {
  moment.locale("pt-br")
  const { t, setActiveRequest, activeRequest, currentOrder } = props
  const [show, setShow] = useState(false)
  const [supportInfo, setSupportInfo] = useState(null)
  const [requestsSteps, setRequestsSteps] = useState([])
  const [obsModal, setObsModal] = useState(false)
  const [obsModalContent, setObsModalContent] = useState("{}")

  function DataAdicionar(data_informada, quantidade) {
    var fator = 24 * 60 * 60 * 1000
    var nova_data = new Date(data_informada.getTime() + quantidade * fator)
    nova_data.setHours(0, 0, 0, 0)

    return nova_data
  }
  function DataSubtrair(data_informada, quantidade) {
    var fator = 24 * 60 * 60 * 1000
    var nova_data = new Date(data_informada.getTime() - quantidade * fator)
    nova_data.setHours(0, 0, 0, 0)

    return nova_data
  }
  function FeriadosFixos(ano) {
    var resultados: Number[] = []
    //Array de datas no formato mes/dia.
    //OBS: O primeiro mes é 0 e o último mes é 11
    var datas = [
      [0, 1],
      [3, 21],
      [4, 1],
      [8, 7],
      [9, 12],
      [10, 2],
      [10, 15],
      [11, 25],
    ]

    for (var z = 0; z < datas.length; z++) {
      resultados.push(new Date(ano, datas[z][0], datas[z][1]).getTime())
    }
    return resultados
  }

  function Pascoa(Y) {
    var C = Math.floor(Y / 100)
    var N = Y - 19 * Math.floor(Y / 19)
    var K = Math.floor((C - 17) / 25)
    var I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15
    I = I - 30 * Math.floor(I / 30)
    I =
      I -
      Math.floor(I / 28) *
        (1 -
          Math.floor(I / 28) *
            Math.floor(29 / (I + 1)) *
            Math.floor((21 - N) / 11))
    var J = Y + Math.floor(Y / 4) + I + 2 - C + Math.floor(C / 4)
    J = J - 7 * Math.floor(J / 7)
    var L = I - J
    var M = 3 + Math.floor((L + 40) / 44)
    var D = L + 28 - 31 * Math.floor(M / 4)

    return new Date(Y, M, D)
  }

  function getnumDiasUteis(startDate, dataFinal) {
    var numDiasUteis = 0
    var arr1 = startDate.split("-")
    var arr2 = dataFinal.split("-")
    var dataAtual = new Date(arr1[0], arr1[1] - 1, arr1[2])
    dataFinal = new Date(arr2[0], arr2[1] - 1, arr2[2])
    var ano_inicial = dataAtual.getFullYear()
    var ano_final = dataFinal.getFullYear()
    var ano = ano_inicial

    var feriados: Number[] = []
    for (var x = ano; x <= ano_final; x++) {
      //OBS: O primeiro mes é 0 e o último mes é 11
      //Feriados fixos.
      feriados = feriados.concat(FeriadosFixos(ano))
      var data_pascoa = Pascoa(ano)

      //Feriados variaveis de acordo com a data da Pascoa
      feriados.push(data_pascoa.getTime())
      feriados.push(DataAdicionar(data_pascoa, 60).getTime())
      feriados.push(DataSubtrair(data_pascoa, 48).getTime())
      feriados.push(DataSubtrair(data_pascoa, 47).getTime())
      feriados.push(DataSubtrair(data_pascoa, 2).getTime())
      ano++
    }

    while (dataAtual <= dataFinal) {
      if (dataAtual.getDay() !== 0 && dataAtual.getDay() !== 6) {
        if (!feriados.includes(dataAtual.getTime())) {
          numDiasUteis++
        }
      }
      dataAtual = DataAdicionar(dataAtual, 1)
    }
    return numDiasUteis
  }

  const getDescricao = annotations => {
    return (
      annotations?.street +
      "," +
      (annotations?.number || "") +
      "," +
      (annotations?.complement || "") +
      " - " +
      annotations?.neighborhood +
      annotations?.city +
      "," +
      annotations?.state +
      "-" +
      annotations?.postcode
    )
  }

  function getYearlyWeekNumber(date) {
    let splitedDate = date.split("-")
    let dateObj = new Date(
      +splitedDate[0],
      +splitedDate[1] - 1,
      +splitedDate[2],
      0,
      0,
      0,
      0
    )
    let firstDayYear = new Date(+splitedDate[0], 0, 1, 0, 0, 0, 0)
    let yearDay = (Number(dateObj) - Number(firstDayYear)) / 86400000 + 1
    let weekInYear = +String((yearDay + firstDayYear.getDay() + 1) / 7).split(
      "."
    )[0]
    return weekInYear
  }

  const latest = async () => {
    const { payload } = await getRequestSteps(activeRequest.id)
    const { requestSteps } = payload
    setRequestsSteps(requestSteps)
  }

  const isJSON = item => {
    let value
    try {
      value = JSON.parse(item)
    } catch (e) {
      return false
    }

    return typeof value === "object" && value !== null
  }

  const getMessage = message => {
    if (typeof message === "string") {
      if (isJSON(message)) {
        return [message, true]
      } else {
        return [message, false]
      }
    }
    if (typeof message === "object") {
      if (message?.message !== undefined) {
        return [
          `${message?.code} - ${message?.status} - ${message?.message}`,
          false,
        ]
      }
      if (message?.msg !== undefined) {
        return [message?.msg, false]
      }
      if (message?.text !== undefined) {
        return [message?.text, false]
      }
    }
    return [message, false]
  }

  useEffect(() => {
    const getRequestInfoCall = async () => {
      try {
        const requestInfo = await getRequestInfo(activeRequest.id)
        requestInfo.newAddress = JSON.parse(
          requestInfo?.payload.support.annotations
        )
        requestInfo.stepOptions = requestInfo?.payload.nextPossibleSteps.map(
          step => ({
            value: step.id,
            label: step.name,
            isLast: step.isLast || false,
          })
        )

        const grupedMetrics = {}
        const aux = requestInfo?.payload.metrics.map(metric => {
          grupedMetrics[metric.dominio] = grupedMetrics[metric.dominio]
            ? grupedMetrics[metric.dominio]
            : []
          grupedMetrics[metric.dominio].push({
            value: metric.id,
            label: metric.name,
          })
        })
        requestInfo.metrics = grupedMetrics
        setSupportInfo(requestInfo)
        setShow(true)
      } catch (error) {
        setActiveRequest(null)
        setShow(false)
        toast("error", "Falha ao tentar abrir chamado.")
      }
    }
    try {
      // console.log(supportInfo?.payload.nextPossibleSteps.length != 0)
      // getRequestInfoCall()
      setShow(true)
      latest()
    } catch (error) {
      console.log(error)
    }
  }, [])

  const parseAnnotationsEndereco = annotation => {
    const ann = annotation ? JSON.parse(annotation) : null
    return ann !== null
      ? `${ann.street}, ${ann.number || ""} - ${ann.complement} - ${
          ann.neighborhood
        } - ${ann.city}, ${ann.state} - ${ann.postcode}`
      : ""
  }

  const parseAnnotationsAnotacao = annotation => {
    const ann = annotation ? JSON.parse(annotation) : null
    return ann !== null
      ? ann?.anotacao !== undefined
        ? `${ann.anotacao}`
        : ""
      : ""
  }

  const [canDownload, setCanDownload] = useState(true)

  const getFileName = annotation => {
    const ann = annotation ? JSON.parse(annotation) : null
    return ann !== null ? (ann?.fileName ? ann?.fileName : "") : ""
  }

  const download = async ({ filename }) => {
    try {
      setCanDownload(false)
      const payload = await downloadFile({ filename })
      const url = window.URL.createObjectURL(new Blob([payload]))
      const link = document.createElement("a")
      link.href = url
      const type = filename.split(".").pop()
      const timestamp = moment().format("DD_MM_YYYY_HH_mm")
      link.setAttribute("download", filename)
      document.body.appendChild(link)
      link.click()
      setCanDownload(true)
    } catch (error) {}
  }

  return (
    <>
      <Modal
        isOpen={show}
        size="xl"
        scrollable={true}
        centered
        toggle={() => {
          setShow(false)
          setActiveRequest(null)
        }}
      >
        <ModalHeader>
          Chamado em andamento
          <button
            type="button"
            onClick={() => {
              setShow(false)
              setActiveRequest(null)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <SimpleBar style={{ height: "80vh" }}>
          <ModalBody>
            <Row>
              <Col>
                <Card outline color="dark" className="border">
                  <CardHeader tag={"h4"} className="bg-primary text-white">
                    Solicitação
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col>
                        <Table>
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>AR</th>
                              <th>Empresa</th>
                              <th>Situação</th>
                              <th>Atendente</th>
                              <th>Criação</th>
                              <th>Canal</th>
                              <th>Transportadora</th>
                              <th>Tipo</th>
                              <th>Anexo</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{activeRequest.id}</td>
                              <td>{currentOrder.shippingTrackerCode}</td>
                              <td>{currentOrder.nameCompany}</td>
                              <td>{activeRequest.currentStepType?.name}</td>
                              <td>{activeRequest.support?.employee?.name}</td>
                              <td>
                                {activeRequest.createdAt
                                  ? moment(
                                      activeRequest.createdAt,
                                      "YYYY-MM-DD"
                                    ).format("DD/MM/YYYY")
                                  : "-"}
                              </td>
                              <td>{activeRequest.channel?.name}</td>
                              <td>{currentOrder.shippingCompany?.name}</td>
                              <td>{activeRequest.type?.name}</td>
                              <td>
                                {getFileName(activeRequest.annotations) !==
                                  "" && (
                                  <button
                                    disabled={
                                      !canDownload ||
                                      getFileName(activeRequest.annotations) ===
                                        ""
                                    }
                                    className="btn btn-link"
                                    onClick={() =>
                                      download({
                                        filename: getFileName(
                                          activeRequest.annotations
                                        ),
                                      })
                                    }
                                  >
                                    [ <FontAwesomeIcon icon={faFileDownload} />{" "}
                                    Baixar ]
                                  </button>
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Label
                        htmlFor="enderecoAtual"
                        className="col-md-2 col-form-label"
                      >
                        Endereço Original
                      </Label>
                      <Col md={10}>
                        <Input
                          className="form-control"
                          type="text"
                          defaultValue={`${currentOrder.shippingStreet}, ${
                            currentOrder.shippingStreetNumber || ""
                          } - ${
                            currentOrder.shippingAddressComplement || ""
                          } - ${currentOrder.shippingNeighborhood} - ${
                            currentOrder.shippingCity
                          }, ${currentOrder.shippingState} - ${
                            currentOrder.shippingPostcode
                          }`}
                          readOnly
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Label
                        htmlFor="descricao"
                        className="col-md-2 col-form-label"
                      >
                        Novo Endereço
                      </Label>
                      <Col md={10}>
                        <Input
                          className="form-control"
                          type="text"
                          defaultValue={parseAnnotationsEndereco(
                            activeRequest.annotations
                          )}
                          readOnly
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Label
                        htmlFor="descricao"
                        className="col-md-2 col-form-label"
                      >
                        Descrição
                      </Label>
                      <Col md={10}>
                        <Input
                          className="form-control"
                          type="text"
                          defaultValue={
                            parseAnnotationsAnotacao(
                              activeRequest.annotations
                            ) || ""
                          }
                          readOnly
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card outline color="dark" className="border">
                  <CardHeader tag={"h4"} className="bg-primary text-white">
                    Retorno
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col>
                        <Card outline color="dark" className="border">
                          <CardHeader
                            tag={"h4"}
                            className="bg-primary text-white"
                          >
                            Histórico
                          </CardHeader>
                          <CardBody>
                            <Table
                              striped
                              bordered
                              hover
                              size="sm"
                              responsive="xl"
                              style={{ fontSize: "12px" }}
                            >
                              <thead>
                                <tr>
                                  <th>Situação</th>
                                  <th>Usuário</th>
                                  <th>Fila</th>
                                  <th>Dt. Criação</th>
                                  <th>Dt. Tratativa</th>
                                  <th>Tempo Tratativa</th>
                                  <th>Observação</th>
                                </tr>
                              </thead>
                              <tbody>
                                {requestsSteps.map(requestStep => (
                                  <tr key={`request-${requestStep.id}`}>
                                    <td>
                                      {requestStep.fromStepType?.name || "-"}
                                    </td>
                                    <td>{requestStep.resolver?.name || "-"}</td>
                                    <td>{requestStep?.queue?.name || "-"}</td>
                                    <td>
                                      {requestStep.createdAt
                                        ? moment(
                                            requestStep.createdAt,
                                            "YYYY-MM-DD HH:mm:ss"
                                          )
                                            .add(-3, "hours")
                                            .format("DD/MM/YYYY HH:mm:ss")
                                        : "-"}
                                    </td>
                                    <td>
                                      {requestStep.resolvedBy
                                        ? moment(
                                            requestStep.updatedAt,
                                            "YYYY-MM-DD HH:mm:ss"
                                          )
                                            .add(-3, "hours")
                                            .format("DD/MM/YYYY HH:mm:ss")
                                        : "-"}
                                    </td>

                                    <td>
                                      {requestStep.resolvedBy
                                        ? getnumDiasUteis(
                                            moment(
                                              requestStep.createdAt
                                            ).format("YYYY-MM-DD"),
                                            moment(
                                              requestStep.updatedAt
                                            ).format("YYYY-MM-DD")
                                          ) - 1
                                        : "-"}
                                    </td>
                                    <td>
                                      {requestStep?.queue?.name ===
                                      "Automatica" ? (
                                        <ul className="list-unstyled hstack gap-1 mb-0 justify-content-center">
                                          <li>
                                            <a
                                              target="_blank"
                                              className={`btn btn-sm btn-secondary`}
                                              onClick={() => {
                                                setObsModalContent(
                                                  JSON.parse(
                                                    requestStep.details || "{}"
                                                  )
                                                )
                                                setObsModal(true)
                                              }}
                                            >
                                              <i
                                                className="mdi mdi-format-list-bulleted"
                                                id={`detailToolTip${requestStep.id}`}
                                              ></i>
                                            </a>
                                            <UncontrolledTooltip
                                              placement="top"
                                              target={`detailToolTip${requestStep.id}`}
                                            >
                                              Observação
                                            </UncontrolledTooltip>
                                          </li>
                                        </ul>
                                      ) : (
                                        requestStep.details
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Card>
                          <CardHeader
                            tag={"h4"}
                            className="bg-primary text-white"
                          >
                            Anotações
                          </CardHeader>
                          <CardBody className="p-0">
                            <SimpleBar style={{ height: "200px" }}>
                              <Table
                                striped
                                bordered
                                hover
                                size="sm"
                                responsive="xl"
                                style={{ fontSize: "12px" }}
                              >
                                <thead>
                                  <tr>
                                    <th>Horário</th>
                                    <th>Usuário</th>
                                    <th>Nota</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {activeRequest.details &&
                                    Object.entries(
                                      JSON.parse(activeRequest.details)
                                    ).map(([key, value], idx) => {
                                      const [msg, hasObj] = getMessage(
                                        value?.message
                                      )
                                      if (hasObj) {
                                        let ruleFraude
                                        ruleFraude = JSON.parse(msg)
                                        if (ruleFraude?.rule === "rule_1") {
                                          ruleFraude[
                                            "description"
                                          ] = `CEP: ${ruleFraude?.extras}`
                                        }
                                        if (ruleFraude?.rule === "rule_2") {
                                          ruleFraude["description"] = [
                                            "Testes realizados: ",
                                          ]
                                          ruleFraude["description"].push(
                                            ...ruleFraude?.extras.map(
                                              el =>
                                                `Número: ${el?.Number}. CEP: ${el?.ZipCode}. `
                                            )
                                          )
                                        }
                                        return (
                                          <tr key={idx}>
                                            <td>
                                              {moment(
                                                key,
                                                "YYYY-MM-DD HH:mm:ss"
                                              ).format("DD/MM/YYYY HH:mm")}
                                            </td>
                                            <td>{value?.userName}</td>
                                            <td>{ruleFraude?.description}</td>
                                          </tr>
                                        )
                                      } else {
                                        return (
                                          <tr key={idx}>
                                            <td>
                                              {moment(
                                                key,
                                                "YYYY-MM-DD HH:mm:ss"
                                              ).format("DD/MM/YYYY HH:mm")}
                                            </td>
                                            <td>{value?.userName}</td>
                                            <td>{msg}</td>
                                          </tr>
                                        )
                                      }
                                    })}
                                </tbody>
                              </Table>
                            </SimpleBar>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </ModalBody>
        </SimpleBar>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => {
              setShow(false)
              setActiveRequest(null)
            }}
          >
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={obsModal}
        toggle={() => {
          setObsModal(!obsModal)
        }}
        centered
      >
        <ModalHeader>
          Observação
          <button
            type="button"
            onClick={() => {
              setObsModal(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <VerticalTimeline
                events={
                  Object.keys(obsModalContent)?.length === 0
                    ? []
                    : Array.from(
                        Object.keys(obsModalContent).map((ev, idx) => {
                          const [msg, isJson] = getMessage(
                            obsModalContent[ev]?.message
                          )
                          if (Object.keys(obsModalContent).length === idx + 1) {
                            return {
                              active: true,
                              title: ev,
                              description: msg,
                              isJson: isJson,
                            }
                          } else {
                            return {
                              active: false,
                              title: ev,
                              description: msg,
                              isJson: isJson,
                            }
                          }
                        })
                      )
                }
              />
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  )
}

ChamadosModal.propTypes = {
  t: PropTypes.any,
  activeRequest: PropTypes.any,
  currentOrder: PropTypes.any,
}

export default withTranslation()(ChamadosModal)
